/* unplugin-vue-components disabled */import script from "./LoginDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginDialog.vue?vue&type=script&setup=true&lang=js"

import "./LoginDialog.vue?vue&type=style&index=0&id=d0428006&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0428006"]])

export default __exports__